import styled, { css } from "styled-components";
import { FlexWrapper } from "../../AdAssistant.styled";

export const LogoImageContainer = styled.div`
  display: flex;
  min-width: ${({ isLandscape }) => (isLandscape ? "160px" : "80px")};
  min-height: ${({ isLandscape }) => (isLandscape ? "80px" : "80px")};

  justify-content: center;
  align-items: center;
  border-radius: 10px;
  border: 1px solid var(--primary-dark-200);
  background-color: var(--primary-dark-100);
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  cursor: pointer;
  transition: border 0.3s ease-in-out;

  ${({ isSelected }) =>
    isSelected &&
    css`
      border: 1px solid var(--primary-green);
    `}
`;

export const LogoPositionButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px 6px 6px 5px;
  border: 1px solid var(--primary-blue-300);
  border-radius: 5px;
  background-color: transparent;
  transition: border 0.3s ease-in-out;
  cursor: pointer;

  ${({ isSelected }) =>
    isSelected &&
    css`
      border: 1px solid var(--primary-blue);
      background-color: var(--primary-dark);
    `}
`;

export const HideLogoCheck = styled.label`
  white-space: nowrap;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 4px;
  input[id="logo"] {
    cursor: pointer;
  }
`;

export const SectionHeader = styled.span`
  color: var(--primary-dark-900);
  font-size: var(--fs-base);
  font-style: normal;
  font-weight: 500;
  line-height: normal;
`;

export const Dropdown = styled.div`
  display: grid;
  place-items: center;
  cursor: pointer;
  flex-shrink: 0;

  > svg {
    transition: transform 0.3s ease;

    ${({ $isOpen }) =>
      $isOpen &&
      css`
        transform: rotate(180deg);
      `}
  }
`;

export const CollapseHeader = styled(FlexWrapper)`
  cursor: pointer;
  color: var(--primary-dark-900);
  font-size: var(--fs-base);
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  padding: 10px 20px;
  width: 100%;
`;

export const CollapseDivider = styled.div`
  width: 100%;
  height: 1px;
  background-color: var(--primary-dark-200);
`;

export const CollapseDividerVertical = styled.div`
  min-width: 1px;
  height: 100%;
  background-color: var(--primary-dark-200);
`;

export const LogoSizeDivider = styled.div`
  width: 100%;
  height: 1px;
  border-bottom: 1px dashed var(--primary-dark-200);
`;

export const CollapseContainerStyle = css`
  display: flex;
  width: 350px;
  flex-direction: column;
  align-items: flex-start;
  border-radius: 5px;
  border: 1px solid var(--primary-dark-200);
  background-color: var(--primary-dark-100);
  min-height: 100%;

  @media screen and (max-width: 1250px) {
    width: unset;
    max-width: 350px;
    min-width: 250px;
  }
  > div {
    width: 100% !important;
  }
`;

export const LogoSizeSelector = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
  background: var(--primary-white);
  padding: 11px 6px;
  border-radius: 4px;
  width: 110px;
`;

export const LogoSizeText = styled.span`
  color: var(--primary-blue);
  font-family: Rubik;
  font-size: var(--fs-base);
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  text-align: center;
  min-width: 50px;
  max-width: 50px;
`;

export const LogoSizeButton = styled.button`
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    opacity: 0.8;
  }
`;

export const NoLogosWarning = styled.span`
  color: var(--primary-blue-300);
  font-size: var(--fs-sm);
  font-style: italic;
  font-weight: 500;
  line-height: normal;
`;
